import { DynamicInputFormType, InputTypes } from "../../../../../Components";

export const NotesConfig: {
  type: string;
  title: string;
  fields: DynamicInputFormType[];
} = {
  type: "Notes",
  title: "Notes",
  fields: [
    {
      dataType: InputTypes.Date,
      accessor: "Date",
      Header: "Date",
    },
    {
      dataType: InputTypes.MultilineString,
      Header: "Note",
      accessor: "Note"
    },
  ],
};
